<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-06-19 11:34:50
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-11-11 11:47:29
 * @Description: 原如是创建页面升级很多客内容页面+很多客只能名片模板
 业务：
 1、定义此模板下的全局比变量
 
 -->
<template>
  <div class="LayoutTemplate">
    <router-view></router-view>
    <Loading v-if="isLoading"></Loading>
    <HuafaBottomLogin v-if="isShowHuafaBottomLogin"></HuafaBottomLogin>
  </div>
</template>

<script>
import Vue from "vue";
import util from "@/utils/utils";
import Cookies from "js-cookie";
import * as comreq from "@/utils/comreq";
import * as qywxApi from "./qywx/qywxApi";
import { mapState, mapMutations } from "vuex";
const Loading = () => import("@/components/loading");
const HuafaBottomLogin = () => import("@/components/huafa_bottom_login");

// 用户事件，即原来的如是H5事件
Vue.prototype.$enumUserEvent = {
  call: 1, //致电
  customerChat: 2, //客服咨询
  survey: 3, //调研
  mall: 4, //商城
  navigation: 5, //导航
  photo: 6, //晒照
  live: 7, //直播
  streetscape: 8, //街景
  peripheral: 9, //周边
  draw: 10, //抽奖
  comment: 11, //评论
  form: 12, //表单
  spreadChat: 13, //传播咨询
  subscribeOnTop: 14, //顶部关注按钮
  subscribe: 15, //关注
};
// 产品类型
Vue.prototype.$enumProductType = {
  henduoke: "henduoke",
  henduobao: "henduobao",
};
// 页面类型
Vue.prototype.$enumPageType = {
  t3: "t3", //很多客 文章
  t4: "t4", //很多客 楼盘
  t5: "t5", //很多宝 文章
  vcard: "vcard", //很多客 智能名片
  t9: "t9", //在线售楼中心
};
Vue.prototype.$openid = Cookies.get("openid");
Vue.prototype.$passport = Cookies.get("passport");
export default {
  components: {
    Loading,
    HuafaBottomLogin,
  },
  props: {},
  data() {
    return {
      isShowHuafaBottomLogin: false,
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isLoading",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "cardInfo",
      "userInfo",
      "hdkUserInfo",
      "rsCardInfo",
    ]),
  },
  methods: {
    ...mapMutations({
      SET_ISSHOWGUIDE: "SET_ISSHOWGUIDE",
      SET_ISLOADING: "SET_ISLOADING",
      SET_ISINMINIPROGRAM: "SET_ISINMINIPROGRAM",
      SET_RECEIVESPREADINFO: "SET_RECEIVESPREADINFO",
      SET_SHARESPREADINFO: "SET_SHARESPREADINFO",
      SET_PAGEINFO: "SET_PAGEINFO",
      SET_CARDINFO: "SET_CARDINFO",
      SET_USERINFO: "SET_USERINFO",
      SET_HDKUSERINFO: "SET_HDKUSERINFO",
      SET_RSCARDINFO: "SET_RSCARDINFO",
    }),
    refreshWxUserInfo() {
      // 自动刷新头像
      var lastTimeRefreshWxUserInfo = util.getStorage(
        "lastTimeRefreshWxUserInfo"
      );
      if (
        !lastTimeRefreshWxUserInfo ||
        (lastTimeRefreshWxUserInfo &&
          new Date() - new Date(lastTimeRefreshWxUserInfo) > 1000 * 60 * 60)
      ) {
        console.log("没有自动刷新过头像，或者距离上次刷新头像已过期");
        comreq.apiRefreshWxUserInfo(this.$openid).then((data) => {
          if (data && data.code == 0 && data.obj) {
            util.setStorage("lastTimeRefreshWxUserInfo", new Date().getTime());
          }
        });
      }
    },
  },
  beforeCreate() {
    let that = this;
    util.getIsInMiniProgram().then(function (data) {
      that.SET_ISINMINIPROGRAM(data);
    });
    if (util.browser.versions.wxwork) {
      // 如果是企业微信环境，那么就把链接替换成企业微信版本
      let urlParam = util.getParamFromUrl(location.href);
      let newUrl = util
        .getUrlRemoveParams(location.href)
        .replace("/h5/", "/qwh5/");
      location.href = util.addUrlParamFromObj(newUrl, urlParam);
    }
  },
  created() {
    const that = this;
    Vue.prototype.$setLoading = function (b) {
      that.SET_ISLOADING(b);
    };
    if (that.$route.query.noguide) {
      that.SET_ISSHOWGUIDE(0);
    } else {
      that.SET_ISSHOWGUIDE(1);
    }
    // 产品类型
    if (that.global.API_DOMAIN.indexOf("henduoke") > -1) {
      Vue.prototype.$productType = Vue.prototype.$enumProductType.henduoke;
    } else if (that.global.API_DOMAIN.indexOf("henduobao") > -1) {
      Vue.prototype.$productType = Vue.prototype.$enumProductType.henduobao;
    }
    // 默认配置
    let defaultConfig = {
      rscuid:
        that.global.SUBDOMAIN == "henduoke"
          ? "o3nM05hrQmGc8Z-ysAVjvc5QcTkk"
          : "",
    };
    Vue.prototype.$pageid = that.$route.query.id || "";
    Vue.prototype.$psn = that.$route.query.psn || "";
    Vue.prototype.$refereeopenid = that.$route.query.refereeopenid || "";
    Vue.prototype.$rscuid = that.$route.query.rscuid || defaultConfig.rscuid;

    Vue.prototype.$clientHeight = document.documentElement.clientHeight;
    Vue.prototype.$clientWidth = document.documentElement.clientWidth;
    Vue.prototype.$tabbarHeight = 50;
    if (location.href.indexOf("/t3") > -1) {
      Vue.prototype.$pageType = Vue.prototype.$enumPageType.t3;
    } else if (location.href.indexOf("/t4") > -1) {
      Vue.prototype.$pageType = Vue.prototype.$enumPageType.t4;
    } else if (location.href.indexOf("/vcard") > -1) {
      Vue.prototype.$pageType = Vue.prototype.$enumPageType.vcard;
    } else if (location.href.indexOf("/t5") > -1) {
      Vue.prototype.$pageType = Vue.prototype.$enumPageType.t5;
    } else if (location.href.indexOf("/t9") > -1) {
      Vue.prototype.$pageType = Vue.prototype.$enumPageType.t9;
    }

    // 设置接收传播信息
    that.SET_RECEIVESPREADINFO({
      id: that.$route.query.id || "",
      psn: that.$route.query.psn || "",
      refereeopenid: that.$route.query.refereeopenid || "",
      rscuid: that.$rscuid,
      entry: that.$route.query.entry
        ? that.$route.query.entry
        : util.getUrlRemoveParams(location.href).indexOf("/t9") > -1
        ? "zxslzx"
        : "",
      t9id: that.$route.query.t9id || "",
      t9psn: that.$route.query.t9psn || "",
    });
    // 设置转发传播信息 这里在拿到用户数据后会根据用户角色调整rscuid
    that.SET_SHARESPREADINFO({
      id: that.$route.query.id || "",
      psn: that.$route.query.psn || "",
      refereeopenid: that.$openid || "",
      rscuid: that.$rscuid,
      entry: that.$route.query.entry
        ? that.$route.query.entry
        : util.getUrlRemoveParams(location.href).indexOf("/t9") > -1
        ? "zxslzx"
        : "",
      t9id: that.$route.query.t9id || "",
      t9psn: that.$route.query.t9psn || "",
    });

    // 提交小程序信息
    if (
      that.$route.query.purephonenumber ||
      that.$route.query.xcxnickname ||
      that.$route.query.xcxheadimg ||
      that.$route.query.xcxcountry ||
      that.$route.query.xcxprovince ||
      that.$route.query.xcxcity
    ) {
      comreq.actEntry(
        that,
        that.$route.query.purephonenumber,
        2,
        that.$route.query.xcxnickname,
        that.$route.query.xcxheadimg,
        that.$route.query.xcxcountry,
        that.$route.query.xcxprovince,
        that.$route.query.xcxcity
      );
    }

    util.checkMapStateCallback(that, ["receiveSpreadInfo"]).then(() => {
      // 很多客产品，获取名片人如是信息，获取名片人很多客信息
      console.log(
        that.$productType,
        that.$enumProductType.henduoke,
        "11111111"
      );
      if (that.$productType == that.$enumProductType.henduoke) {
        comreq
          .getUserInfo(that.receiveSpreadInfo.rscuid)
          .then(function (userInfo) {
            if (userInfo.user.appid && userInfo.user.unionid) {
              comreq
                .findUserByUnionid(userInfo.user.appid, userInfo.user.unionid)
                .then(function (cardInfo) {
                  that.SET_CARDINFO(cardInfo);
                  Vue.prototype.$cuid =
                    cardInfo && cardInfo.User && cardInfo.User.Id;
                });
            } else {
              // 如果没有传播的rscuid，就用小原的，现在不会走这里了，因为会设置rscuid为小原的通过接口拿数据。这里只做假数据了。
              that.SET_CARDINFO({
                Ui: {
                  HeadImg:
                    "https://assets.wxmp.ruthus.com/henduoke/ai/new_head.png",
                  Name: "小原",
                },
                User: {
                  Company: "原圈科技",
                  Phone: "18801498411",
                },
              });
            }
          });
      } else {
        if (that.receiveSpreadInfo.rscuid) {
          comreq.getUserInfo(that.receiveSpreadInfo.rscuid).then((obj) => {
            // rscuid已经不是销售了
            if (obj.role && obj.role.length == 0) {
              let newUrlP = util.getParamFromUrl(location.href);
              delete newUrlP.rscuid;
              location.href = util.addUrlParamFromObj(
                util.getUrlRemoveParams(location.href),
                newUrlP
              );
            }
          });
          comreq.getUserInfo2(that.receiveSpreadInfo.rscuid).then((obj) => {
            that.SET_RSCARDINFO(obj);
          });
        }
      }
      // 获取用户如是信息
      comreq.getUserInfo().then(function (userInfo) {
        comreq.fansInfo(userInfo.user.openid).then((fansInfo) => {
          userInfo = util.filterUserInfoAndFansInfo(userInfo, fansInfo);
          that.SET_USERINFO(userInfo);
        });

        // 很多客产品，获取用户很多客信息
        if (that.$productType == that.$enumProductType.henduoke) {
          if (userInfo.user.appid && userInfo.user.unionid) {
            comreq
              .findUserByUnionid(userInfo.user.appid, userInfo.user.unionid)
              .then(function (hdkUserInfo) {
                that.SET_HDKUSERINFO(hdkUserInfo);
              });
          }
        }
      });

      // 绑定微信小程序信息
      if (
        that.$route.query.xcxuid &&
        that.$route.query.xcxappid &&
        that.$route.query.xcxprojectid
      ) {
        comreq
          .bindRsGzhinfo({
            uid: that.$route.query.xcxuid,
            appid: that.$route.query.xcxappid,
            projectid: that.$route.query.xcxprojectid,
            gzhAppid: that.global.APPID,
            gzhOpenid: that.$openid,
            gzhPassport: that.$passport,
          })
          .then((data) => {
            console.log("bindRsGzhinfo", data);
          });
      }
      // 绑定外部系统用户信息
      if (that.$route.query.account && that.$route.query.accountType) {
        qywxApi
          .bindUserAccount({
            account: that.$route.query.account,
            accountType: that.$route.query.accountType,
            openid: that.$openid,
          })
          .then((res) => {
            console.log(111, "bindUserAccount", res);
          });
      }

      if (util.checkIsHuafa() && false) {
        that.isShowHuafaBottomLogin = true;
      }
    });
    // this.refreshWxUserInfo();
  },
  mounted() {
    let tmpInterval = setInterval(() => {
      if (document.getElementById("index_scrim")) {
        document.getElementById("index_scrim").style.display = "none";
        clearInterval(tmpInterval);
      }
    }, 100);
  },
};
</script>
<style lang="css" scoped>
.LayoutTemplate {
}
</style>